import { getBizEntityUrl } from "../utils";

export const CreateCopilot = {
  attributes: {
    createCopilotButton: "create-copilot-button",
    createCopilotSuggestionsDiv: "create-copilot-suggestions-div",
    createCopilotSuggestionCardDiv: "create-copilot-suggestion-card-div",
    createCopilotSuggestionCardButton: "create-copilot-suggestion-card-button",
    startCopilotOnBoardingButton: "start-copilot-onboarding-button",
    kpiStep: "kpi-step",
    cohortCard: "cohort-card",
    cohortCardDescription: "cohort-card-description",
    kpiStepNextButton: "kpi-step-next-button",
    opCard: "op-card",
    opCardTitle: "op-card-title",
    opCardDescription: "op-card-description",
    opCardPreviewButton: "op-card-preview",
    patternStepNextButton: "pattern-step-next-button",
    saveCopilotButton: "save-copilot-button",
    goToCopilotHomeButton: "go-to-co-pilot-home-button",
    subscribeWizardStep: "subscribe-wizard-step",
    slackTemplate: "slack-template",
    insightPreview: "insight-preview",
    subscribeNextAction: "subscribe-next-action",
    customCreateCopilotButton: "custom-create-copilot-button",
    copilotNameInput: "copilot-name-input",
    addKbButton: "add-kb-button",
    kbNameInput: "kb-name-input",
    kbDescriptionInput: "kb-description-input",
    kbContentInput: "kb-content-input",
    saveKbButton: "save-kb-button",
    createCopilotButtonWithCustomKb: "create-copilot-button-with-custom-kb",
    enterCopilotName: "enter-copilot-name",
    onboardingCreateCopilotButton: "onboarding-create-copilot-button"
  },
  requestUrls: {
    fetchSubVerticals: getBizEntityUrl("usecaseCatalog/*/suggest*"),
    suggestCopilot: getBizEntityUrl("usecase/v2/creation"),
    suggestCopilotStatus: getBizEntityUrl("usecase/v2/status"),
    listUserService: "/api-proxy/api/**/userService/list*",
    onBoardCopilotStart: getBizEntityUrl("usecase/v2/onboardCopilotStart"),
    onBoardCopilotStatus: getBizEntityUrl("usecase/v2/onboardCopilotStatus?pollId=*"),
    saveCopilot: getBizEntityUrl("usecase/v2/save"),
    suggestKpis: getBizEntityUrl("usecase/v2/suggest/kpis"),
    cohortStart: getBizEntityUrl("usecase/v2/cohortStart"),
    cohortStatus: getBizEntityUrl("usecase/v2/cohortStatus*"),
    generateKpiQuery: {
      method: "POST",
      url: getBizEntityUrl("usecase/v2/generateKPIQueryDef"),
      isNotCritical: true
    },
    generateInsights: getBizEntityUrl("usecase/v2/generateInsights"),
    generateDataQueryDef: {
      method: "POST",
      url: getBizEntityUrl("usecase/v2/generateDataQueryDef"),
      isNotCritical: true
    },
    fetchIncidentSchema: getBizEntityUrl("op10ze/redis*/schema*"),
    chat: getBizEntityUrl("chat/continue?*"),

    suggestedDashboards: getBizEntityUrl("usecase/v2/suggest/dashboards"),
    generateDashboardPreview: {
      method: "POST",
      url: getBizEntityUrl("generateFromPrompt*"),
      isNotCritical: true
    },
    generateDashboardPreviewStatus: {
      method: "POST",
      url: getBizEntityUrl("generateFromPrompt/*/status"),
      isNotCritical: true
    },
    deleteUseCase: {
      method: "DELETE",
      url: getBizEntityUrl("usecase/*")
    },

    searchOp: getBizEntityUrl("op10ze/search"),
    fetchIncidents: getBizEntityUrl("op10ze/fetch/incidents/data*"),
    getIncidentData: getBizEntityUrl("op10ze/redis*/incident/*"),
    addDimensions: getBizEntityUrl("usecase/*/discover/*/addDimensions?*"),

    feedCommands: getBizEntityUrl("usecase/*/user/feedCommands"),
    feedList: getBizEntityUrl("usecase/*/user/feedList?*"),
    fetchSuggestions: getBizEntityUrl("suggestions?*"),
    fetchOpSchema: getBizEntityUrl("op10ze/*/schema?*")
  },
  requestKeysToIgnoreIntercept: ["cohortPoll"]
};
